import { createBaseQuery } from '../helper/createBaseQuery'
import { tokenSlice } from '../slice/tokenSlice'

const buyerApi = tokenSlice.injectEndpoints({
  reducerPath: 'buyer',
  baseQuery: createBaseQuery(),
  endpoints(builder) {
    return {
      getBuyer: builder.query({
        query: (businessUnitId) => {
          return {
            url: `Buyer/GetBuyers/${businessUnitId}`,
            method: 'GET',
          }
        },
      }),
    }
  },
})

export const { useGetBuyerQuery } = buyerApi
export { buyerApi }